<template>
  <div class="text-secondary">
    <span class="bold" v-no-capture>{{ actor }}</span
    >&nbsp;<span>{{ changeLabel }} the</span>&nbsp;<span class="bold">{{ fieldName }}</span
    >&nbsp; <span v-if="showChangedValue">to</span>&nbsp;
    <span class="bold" v-if="showChangedValue">
      <template v-if="event.field === 'status'">
        <span>
          <i :class="statusIcon(event.changes.new)"></i>&nbsp;<span class="field-value-new">{{
            statusLabel(event.changes.new)
          }}</span>
        </span>
      </template>
      <template v-else>
        {{ formatValue(event.changes.new) }}
      </template>
    </span>
  </div>
</template>

<script>
import { statusIcon, statusLabel } from '@/constants/initiative'
import { getTimeOrDate } from '@/utils/formatDate'

export default {
  name: 'FieldChangePhrase',
  props: ['event'],
  computed: {
    actor() {
      const actor = this.$store.getters.userById(this.event.actorId)
      return actor?.displayName
    },
    changeLabel() {
      if (this.event.field === 'description') {
        return this.event.changeType
      } else return 'changed'
    },
    showChangedValue() {
      return this.event.field !== 'description'
    },
    fieldName() {
      switch (this.event.field) {
        case 'description':
          return 'note'
        case 'due_date':
          return 'due date'
        default:
          return this.event.field
      }
    }
  },
  methods: {
    statusIcon,
    statusLabel,
    formatValue(value) {
      if (this.event.field === 'due_date') {
        return getTimeOrDate(value)
      }
      return value
    }
  }
}
</script>

<style scoped></style>
